import { useEffect } from "react";
import useSessionStorage from "../../hooks/useSessionStorage";
import { getInstanceLogo } from "./instance";

const DomainIcons = () => {
    const storage = useSessionStorage();
    const login = storage.getItem("login");
  
    const mainIcon = getInstanceLogo(true);
  
    useEffect(() => {
      let link = document.querySelector("link[rel~='icon']");
      let titleElement = document.querySelector("title");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      if (!titleElement) {
        titleElement = document.createElement('title');
        document.getElementsByTagName('head')[0].appendChild(titleElement);
      }
      if (link) {
        link.href = mainIcon ? mainIcon :
          ((
            login?.jobTypeFlags?.jobTypeList?.length
              ? login?.jobTypeFlags?.jobTypeList[0]?.jobTypeId === 6
              : login?.jobTypeFlags?.jobTypeId === 6 ||
                login?.jobTypeFlags?.jobTypeList?.length
                ? login?.jobTypeFlags?.jobTypeList[0]?.jobTypeId === 7
                : login?.jobTypeFlags?.jobTypeId === 7
          )
            ? "assets/images/brand/ICON-DDS.png"
            : "") ||
          (login?.jobTypeFlags?.jobTypeId === 0 ||
            login?.jobTypeFlags?.jobTypeId === 1 ||
            login?.jobTypeFlags?.jobTypeId === 3 ||
            login?.jobTypeFlags?.jobTypeId === 8 ||
            login?.jobTypeFlags?.jobTypeId === 4 ||
            login?.jobTypeFlags?.jobTypeId === 11
            ? "assets/images/brand/ICON-XL.png"
            : "") ||
          (login?.jobTypeFlags?.jobTypeId === 2
            ? "assets/images/brand/ICON-SEC.png"
            : "") ||
          (login?.jobTypeFlags?.jobTypeId === 5
            ? "assets/images/brand/ICON-YUM.jpg"
            : "") ||
          "assets/images/brand/EMP-ICON.png"
      }
      if (titleElement) {
        titleElement.innerHTML = `Overture Employer Login`
      }
  
    }, []);
return <></>  
}

export default DomainIcons